export default {
    dh_dashboard_metrics: '/api/v1/dashboard/digital-human/metrics',
    dh_dashboard_preferences: '/api/v1/preference',
    sidebar: '/api/v2/sidebar',
    cube_api: '/api/v1/cube',
    my_analytics: '/api/v1/my-analytics',
    schedule: '/api/v1/schedule',
    favorites: '/api/v1/favorites',
};
